/* istanbul ignore file */
import React from 'react'
import { createRoot } from 'react-dom/client'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import { SMALL_MAP_WIDTH } from '../../constants/map'
import { getMaxResultsAllowed } from '../../util/maxResultsAllowed'
import cls from './index.scss'
const cx = classnames.bind(cls)

const MapHeader = ({ title }) => (
  <div className={cx('header')} data-elm-id='map_header'>
    {title}
  </div>
)
MapHeader.propTypes = {
  title: PropTypes.string,
}

/**
 * Appends a div to the parent map if all the stars align (and one hasn't been added already)
 * @param {*} mapElement
 * @returns
 */
export const appendHeaderDiv = mapElement => {
  const headerDiv = document.getElementById('map-header')
  if (headerDiv) return headerDiv

  const map = mapElement
  const TOP_LEFT = window?.google?.maps?.ControlPosition?.TOP_LEFT

  if (!document || !map?.controls || !TOP_LEFT) return null
  if (map.controls[TOP_LEFT]?.length) return map.controls[TOP_LEFT][0] // assumes no other controls here

  const div = document.createElement('div')
  div.id = 'map-header'
  map.controls[TOP_LEFT].push(div)
  return div
}
/**
 * Renders the title e.g. "Showing 500 of 678".  Message varies if total more than max allowed AND depending on
 * map width (smaller maps are a shorter message)
 * @param {*} mapElement
 * @param {*} count
 * @param {*} total
 * @returns
 */
export const renderHeader = (mapElement, count, total, featureFlags) => {
  if (typeof document === 'undefined') return null

  const headerDiv = appendHeaderDiv(mapElement)

  if (headerDiv) {
    const totalFormatted = total.toLocaleString('en-US')
    const mapWidth =
      document.querySelector('[data-elm-id="Asset_Map_View"]').clientWidth || 0

    let title = `Showing ${count}`

    if (total > getMaxResultsAllowed(featureFlags)) {
      if (mapWidth > SMALL_MAP_WIDTH)
        title = `Showing ${count} of ${totalFormatted}`
      else title = `${count} of ${totalFormatted}`
    }

    // Reuse a single React 18 root per header container (renderHeader is called
    // repeatedly on marker/count updates; createRoot-per-call would warn).
    const root =
      headerDiv.__reactRoot ?? (headerDiv.__reactRoot = createRoot(headerDiv))
    root.render(count ? <MapHeader title={title} /> : null)
  }
}

export default MapHeader
